import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
import FormPrefSelector from '../../components/circle/form_pref_selector';
import Loader from '../../components/loader';
import compressImage from '../../../../lib/image_compressor';

const sagaMiddleware = createSagaMiddleware();
createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class FormPage2 extends Component {
  render() {
    return <Root isApp={this.props.isApp} type={this.props.type} />;
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pref_id: '主な活動地域を選択',
      loading: false
    };
    this.onClickPageBtn = this.onClickPageBtn.bind(this);
    this.onChangeMainImage = this.onChangeMainImage.bind(this);
    this.onChangeFields = this.onChangeFields.bind(this);
    this.handlePrefChange = this.handlePrefChange.bind(this);
    this.onChangeRecruitAgeGroups = this.onChangeRecruitAgeGroups.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.imageUploadStatus) {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1000);
    }
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onClickPageBtn(e) {
    e.preventDefault();
    let circle = this.props.circle;
    const nextPage = e.target.value;
    if (nextPage === "1") {
      if (circle.is_oshikatsu_circle) {
        this.props.changePage("oshikatsu_circles");
      } else {
        this.props.changePage("1");
      }
      return;
    }
    this.props.updateCircle(circle);
    this.props.changePage(nextPage);
  }

  async onChangeMainImage(e) {
    this.setState({ loading: true });
    let file = e.target.files[0];
    file = await compressImage(file);
    this.props.uploadCircleImage(this.props.circle, file);
  }

  onChangeFields(e) {
    let circle = this.props.circle;
    circle[e.target.id] = e.target.value;
    this.props.changeFields(circle);
  }

  handlePrefChange() {
    const elements = document.getElementsByName('pref_id');
    let pref_id;
    for (let i = 0; i <= elements.length; i++) {
      if (elements[i].checked) {
        pref_id = elements[i].value;
        break;
      }
    }

    let circle = this.props.circle;
    circle['pref_id'] = pref_id;
    this.props.changeFields(circle);
    this.setState({
      pref_id: circle.pref_id
    });
  }

  onChangeRecruitAgeGroups(e) {
    const nowChecked = e.target.value;
    const elements = document.getElementsByName('age');
    let recruitAge = [];
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].checked) {
        if (
          elements[i].value === '指定しない' &&
          elements[i].value == nowChecked
        ) {
          recruitAge = ['指定しない'];
          break;
        }
        if (elements[i].value === '指定しない') continue;
        recruitAge.push(elements[i].value);
      }
    }
    if (recruitAge.length === 0) recruitAge = ['指定しない'];
    if (recruitAge.length >= 5) recruitAge = ['指定しない'];

    let circle = this.props.circle;
    this.props.changeFields(circle);
  }

  render() {
    const circleName = this.props.type === 'department' ? '部署' : 'サークル';
    const namePlaceholder = this.props.type === 'department' 
      ? '部署名を入力(例：人事部)' 
      : 'サークル名を入力(例：サッカー好き集まれ)';
    const detailPlaceholder = this.props.type === 'department'
      ? '部署の内容を記載しましょう。（例：人事部は、社員の採用・育成・サポートを通じ、企業と人の成長を支える部署です。）'
      : '何をするサークルかを記載しましょう。サークル設立の思いなども記載しましょう。（例：みんなで楽しく登山をしたいと思ってサークルを設立しました。主に日帰り登山をしようと思っています。高尾山や鍋割山などに行こうと思っています。）';

    return (
      <div>
        <main
          className="bg-gray h-100 pt-3 min-vh-100"
          style={{
            paddingBottom: this.props.isApp == false ? '180px' : '72px'
          }}
        >
          <div className="container col-md-8 col-lg-6">
            <ol className="list-unstyled list-makecircle d-flex text-center justify-content-center mt-3">
              <li
                className="list-makecircleitem text-fz-small active"
                onClick={this.onClickPageBtn}
                value="2"
              >
                基本情報
              </li>
              <li
                className="list-makecircleitem text-fz-small"
                onClick={this.onClickPageBtn}
                value="3"
              >
                設定
              </li>
            </ol>
            <div className="mt-3 mb-2">
              <div className="container">
                <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
                  メイン写真
                </p>
                <p className="text-fz-small text-black-50">
                  ※ 画像をタップして登録。画像は横縦比1:1で切り取られます。
                </p>
              </div>
              <label className="container col-12 col-md-6">
                {this.state.loading ? (
                  <Loader isActive={this.state.loading} />
                ) : (
                  <div className="adjust-box adjust-box-1x1">
                    <img
                      src={
                        this.props.circle.main_image_url
                          ? this.props.circle.main_image_url
                          : `/assets2019/img/icon_camera.svg`
                      }
                      className="rounded w-100 object-fit-cover adjust-box-inner"
                    />
                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/gif"
                      onChange={this.onChangeMainImage}
                      name="otherImage_5"
                      id="5"
                      style={{ display: 'none' }}
                    />
                  </div>
                )}
              </label>
            </div>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              {circleName}名
            </p>
            <p className="message-required d-inline-block mb-2 ml-1">必須</p>
          </div>
          <div className="shadow-sm mb-0 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <input
                name=""
                id="name"
                className="p-0 w-100 textarea--eventreport"
                placeholder={namePlaceholder}
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.name}
              />
            </div>
          </div>
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              {circleName}の説明
            </p>
          </div>
          <div className="shadow-sm mb-0 bg-white pt-3 pb-2">
            <div className=" container col-md-8 col-lg-6">
              <textarea
                name=""
                id="about"
                cols="5"
                rows="6"
                className="p-0 w-100 textarea--eventreport"
                placeholder={detailPlaceholder}
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.about}
              />
            </div>
          </div>
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              主な活動場所
            </p>
            <p className="message-required d-inline-block mb-2 ml-1">必須</p>
          </div>
          <div className="shadow-sm mb-2_5 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <ul className="p-0 m-0">
                <FormPrefSelector
                  countriesPrefs={this.props.countriesPrefs}
                  handlePrefChange={this.handlePrefChange}
                  closeModalPrefSelector={this.closeModalPrefSelector}
                  circle={this.props.circle}
                  name="pref_id"
                />
              </ul>
            </div>
          </div>
          {/* <div className="container col-md-8 col-lg-6">
          <p className="text-fz-small text-black-50 mb-2">より詳細な場所があれば入力してください</p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className=" container col-md-8 col-lg-6 p-3_5">
            <input
              name=""
              id="place"
              className="p-0 w-100 textarea--eventreport"
              placeholder="詳細な場所（例：山田１丁目 味の素スタジアム"
              onChange={this.onChangeFields}
              defaultValue={this.props.circle.place}
            />
          </div>
        </div> */}
          {/* <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-0 mt-2 d-inline-block">活動予定日時</p>
          <p className="text-fz-small text-black-50 mb-2_5">目安でご記入ください</p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className=" container col-md-8 col-lg-6 p-3_5">
            <input
              name=""
              id="activity_frequency"
              className="p-0 w-100 textarea--eventreport"
              placeholder="指定しない"
              onChange={this.onChangeFields}
              defaultValue={this.props.circle.activity_frequency}
            />
          </div>
        </div> */}
          {/* <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">費用</p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className=" container col-md-8 col-lg-6 p-3_5">
            <input
              name=""
              id="membership_fees"
              className="p-0 w-100 textarea--eventreport"
              placeholder="無料"
              onChange={this.onChangeFields}
              defaultValue={this.props.circle.membership_fees}
            />
          </div>
        </div> */}
          {/* <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3 d-inline-block">ホームページ</p>
        </div>
        <div className="shadow-sm mb-5 bg-white">
          <div className=" container col-md-8 col-lg-6 p-3">
            <input name=""
              id="web_url"
              className="p-0 w-100 textarea--eventreport"
              placeholder="http://tunagate.com"
              onChange={this.onChangeFields}
              defaultValue={this.props.circle.web_url}
            />
          </div>
        </div> */}
        </main>

        <div className="fixed-bottom" style={{ paddingBottom: '8px' }}>
          <div className="container col-md-8 col-lg-6">
            <div
              className="row"
              style={{ marginBottom: this.props.isApp == true ? '24px' : '' }}
            >
              <div className="col">
                <button
                  type="button"
                  className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                    this.props.isApp == false ? 'mb-2' : ''
                  }`}
                  onClick={this.onClickPageBtn}
                  value="3"
                >
                  次へ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    isApp: ownProps.isApp,
    type: ownProps.type
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changePage: pageNum => {
      dispatch(Module.actions.changePage({ pageNum }));
    },
    uploadCircleImage: (circle, file) => {
      dispatch(Module.actions.uploadCircleImage({ circle, file }));
    },
    changeFields: circle => {
      dispatch(Module.actions.changeFields({ circle }));
    },
    updateCircle: (circle, isSubmit = false) => {
      dispatch(Module.actions.updateCircle({ circle, isSubmit }));
    }
  };
};

const Root = connect(
  mapStateToProps,
  mapDispatchToProps
)(TmpRoot);
